/* unplugin-vue-components disabled */import { render } from "./Data.vue?vue&type=template&id=38276473"
import script from "./Data.vue?vue&type=script&lang=js"
export * from "./Data.vue?vue&type=script&lang=js"

import "./Data.vue?vue&type=style&index=0&id=38276473&lang=scss"

import exportComponent from "/data/repos/231_20260324134036/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__